import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getSVGImagePath } from "./SVGImagePath";
import { SVGIconWrapper } from "./SVGIconWrapper";
import { Rotation } from "../../../constants";
import { EmptyComponent } from "../EmptyComponent";

const SVGIconV3 = props => {
  const { iconName, width, height, rotation, color, hoverColor, onClick } =
    props;

  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(getSVGImagePath(iconName));
  }, [iconName]);

  if (!iconName) return <EmptyComponent />;

  return (
    <SVGIconWrapper
      id={iconName}
      src={path}
      width={width}
      height={height}
      rotation={rotation}
      color={color}
      hoverColor={hoverColor}
      onClick={onClick}
    />
  );
};

SVGIconV3.defaultProps = {
  rotation: Rotation.Default
};

SVGIconV3.propTypes = {
  iconName: PropTypes.string,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  rotation: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  onClick: PropTypes.func
};

export default React.memo(SVGIconV3);
